import { useEffect, useState } from "react";

import { ProjectActivitiesConstants } from "../../constants";
import { SelectData } from "../../models";
import { GetTaskBoardResponse, searchActivities } from "../../service/query";
import { Status } from "../../service/Shared";

/*
  The activities a workflow task can be related to: those in progress on the workflow's project, plus those
  on its group when it has one. A general task has no activity relation — its objectType/objectUuid carry
  its parent instead — and a panel with no workflow has no project to ask about, so both leave this empty.
*/
export const useTaskActivityOptions = (
  workflow: GetTaskBoardResponse["results"][number] | undefined,
  refresh: boolean
): SelectData => {
  const [activitySelectData, setActivitySelectData] = useState<SelectData>([]);

  useEffect(() => {
    const getAndSetActivityList = async (): Promise<void> => {
      if (!workflow?.projectUuid) return;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const filter: any = {
        status: {
          operator: "in",
          value: [ProjectActivitiesConstants.STATUS_IN_PROGRESS],
        },
      };

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let filterResults: any = {
        project: {
          uuid: {
            operator: "eq",
            value: workflow.projectUuid,
          },
        },
      };

      // If in group, filter by group
      if (workflow.groupUuid) {
        filterResults = {
          ...filterResults,
          group: {
            uuid: {
              operator: "eq",
              value: workflow.groupUuid || null,
            },
          },
        };
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const filterGroups: any = [
        {
          operator: "or",
          filter: {
            results: filterResults,
          },
        },
      ];

      const response = await searchActivities({
        paging: {
          limit: 10,
          beforeCursor: "",
          afterCursor: "",
        },
        filter: {
          results: filter,
        },
        filterGroups,
      });

      if (response.status === Status.Success && response.data?.results) {
        setActivitySelectData(
          response.data.results.flatMap((el) =>
            el.uuid && el.activityDefinition.displayName
              ? { key: el.uuid, value: el.activityDefinition.displayName }
              : []
          )
        );
      }
    };

    getAndSetActivityList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflow?.uuid, workflow?.projectUuid, workflow?.groupUuid, refresh]);

  return activitySelectData;
};
